import { useGtm } from "@gtm-support/vue-gtm";

export function trackEvent(data) {
  const gtm = useGtm();

  if (useRuntimeConfig().public.isProd) {
    gtm.trackEvent(data);
  }
}
